import { FormControl, ValidatorFn, AbstractControl } from '@angular/forms';
import { format } from 'date-fns';

export function datetimeFormatValidator(): ValidatorFn {
    const invalidFormatError = { invalidDatetimeFormat: 'Invalid format pattern.' };
    return (control: AbstractControl) => {
        if (!control.value) {
            return null;
        }
        try {
            const formatted = format(new Date(), control.value);
            if (!!formatted && typeof formatted === 'string') {
                return null;
            }
            return invalidFormatError;
        } catch (e) {
            return invalidFormatError;
        }
    };
}

export const DOT_NET_DATETIME_FORMAT_VALIDATOR = /^(?:[dfFghHKmMstyz:/_-]|(?:'.+')|(?:".+"))+$/gm;
export function dotNetDateTimeFormatValidator(): ValidatorFn {
    const invalidDotNetFormatError = { invalidDatetimeFormat: 'Invalid format pattern.' };
    return (control: AbstractControl) => {
        if (!control.value) {
            return null;
        }
        try {
            const match = control.value.match(DOT_NET_DATETIME_FORMAT_VALIDATOR);
            if (match) {
                return null;
            }
            return invalidDotNetFormatError;
        } catch (e) {
            return invalidDotNetFormatError;
        }
    };
}
